export type ChoirMembersGuideStepId = "invite_member";

export interface ChoirMembersGuideState {
    completed: ChoirMembersGuideStepId[];
    dismissed_at: string | null;
    completed_at: string | null;
}

export const CHOIR_MEMBERS_GUIDE_STEPS: ChoirMembersGuideStepId[] = [
    "invite_member",
];

export function createDefaultChoirMembersGuideState(
    seed?: Partial<ChoirMembersGuideState> | null
): ChoirMembersGuideState {
    const completedSeed = seed?.completed;
    const completed = Array.isArray(completedSeed)
        ? completedSeed.filter((step): step is ChoirMembersGuideStepId => CHOIR_MEMBERS_GUIDE_STEPS.includes(step as ChoirMembersGuideStepId))
        : [];

    return {
        completed,
        dismissed_at: seed?.dismissed_at ?? null,
        completed_at: seed?.completed_at ?? null,
    };
}

export function getChoirMembersGuideNextStep(state: ChoirMembersGuideState): ChoirMembersGuideStepId | null {
    const completed = new Set(state.completed || []);
    return CHOIR_MEMBERS_GUIDE_STEPS.find((step) => !completed.has(step)) || null;
}

export function isChoirMembersGuideStepCompleted(
    state: ChoirMembersGuideState,
    step: ChoirMembersGuideStepId
): boolean {
    return state.completed.includes(step);
}

export function markChoirMembersGuideStep(
    state: ChoirMembersGuideState,
    step: ChoirMembersGuideStepId
): ChoirMembersGuideState {
    if (state.completed.includes(step)) {
        return state;
    }

    const nextCompleted = [...state.completed, step];
    const done = nextCompleted.length >= CHOIR_MEMBERS_GUIDE_STEPS.length;

    return {
        ...state,
        completed: nextCompleted,
        completed_at: done ? state.completed_at || new Date().toISOString() : state.completed_at,
    };
}
